export const loginLabels = {
	urlLine: "Go to your computer or phone's web browser & visit:",
	url: 'dstv.stream/tv',
	codeLine: 'then enter this code',
	codeLineSignin: 'to sign in on this device.',
}

export const restartLabel = 'Watch From Start'
